import { BaseFilterModel, DataGridFilter } from '../create-data-grid-filter';

export const oneOfFilterModelName = 'one_of_filter';

export type OneOfFilterModel = BaseFilterModel<
  number,
  typeof oneOfFilterModelName
>;

export type RenderOptionsList = {
  label: string;
  value: number;
}[];

export type OneOfFilterParams = {
  /**
   * The name of the field for filtering in the server-side API
   */
  filterName: string;
  options: RenderOptionsList;
  closeWhenChanged?: boolean;
};

type CreateOneOfFilterModelParams = {
  value: number;
  filterName: string;
};

export type OneOfDataGridFilter = DataGridFilter<
  OneOfFilterModel,
  OneOfFilterParams
>;

export const createOneOfFilterModel = ({
  value,
  filterName,
}: CreateOneOfFilterModelParams): OneOfFilterModel => {
  return {
    filterModelName: oneOfFilterModelName,
    value,
    filterName,
  };
};
